<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">{{title}}</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">名称</div>
                        <div class="value"> <input readonly class="ui-input full-width" type="text" v-model="formData.name" /></div>
                    </div>
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">内容</div>
                        <div class="value" id="content"> <RichText  ref="rtf"  class="full-width" v-model="formData.content"   /></div>
                    </div>
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="appendToMy">添加到我的版本</div>
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="sendTo">发送到指定版本</div>
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="wordTotal">关键字统计</div>      
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">关闭</div>         
            </div>
            <SendUpdateModal :mData="formData" :open="showSendUpdateModal" @close="showSendUpdateModal = false"  @confirm="sendUpdateConfirm" ></SendUpdateModal>
        </div>
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import {appendToMy} from '@/api/api.js';
    import SendUpdateModal from '@/views/modal/SendUpdateModal'
    import {sendMsgs,editLogs} from '@/api/api.js';
    import {strCount} from '@/utils/sysUtils'


    export default {
        name:'DocShowModal',
        created() {
        },
        components:{RichText,SendUpdateModal},
        props:{
            title:{},
            open:{},
            mdata:{},
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue == true) {
                        if (this.mdata != null) {
                            this.formData.id = this.mdata.id;
                            this.formData.name = this.mdata.name; 
                            this.formData.content =  this.mdata.content; 
                            this.formData.docId = this.mdata.docId;  
                            this.formData.files = this.mdata.files;                                  
                        }
                    } 
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                showSendUpdateModal: false,
                show: null,
                formData:{
                },
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),

            }
        },
        methods:{
            
            close() {
                this.$emit("close")
            },
            wordTotal() {
                this.$showInputBox({
                    caption:"输入",
                    inputValue: "",
                    callback:(data) => {
                        let count = strCount(data, this.formData.content);
                        this.$closeInputBox();
                        this.$showToast({
                            msg: '出现次数：' + count 
                        }) 
                    }
                }) 
                console.log("count====",count);
            },
            appendToMy() {
                //let postBody = {id: this.formData.docId, content: this.formData.content};
                //console.log(postBody);
                this.$showLoading();
                appendToMy(this.formData).then((res) => {
                    this.$closeLoading();
                    if (res.data.success == true) {
                        this.$showToast({
                            msg: '添加成功！' 
                        }) 
                    }
                }) 
            },
            sendTo() {
                this.showSendUpdateModal = true;
                
            },
            sendUpdateConfirm(data) {
                let postBody = [];
                console.log("files=====", this.files);
                console.log("data=====", data);
                let content = data.content;
                let allUser = data.allUser;
                let selectVer = data.selectVer;

                this.formData.files.forEach(item => {
                    
                    if (content.length > 0) {
                        if (allUser == false) {
                            if (item.userId == selectVer) {
                                postBody.push({
                                    "content": content, 
                                    "msgType": 4,
                                    "toUserId": item.userId,
                                    "toUserName": item.userName,
                                    "fileId": item.id
                                }) 
                            }
                        }  
                    }                 
                });
                console.log("postBody=====", postBody);
                sendMsgs(postBody).then((res) => {
                    if (res.data.success == true) {
                        this.$showToast({
                            msg: '操作成功！' 
                        }) 
                        this.showSendUpdateModal = false;
                    }
                })                           
            },
            

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 15px;
    }
    .doc-edit-modal {
        width: 1100px;
        height: 835px;
    }
    .edit-area {
       width: 1060px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/DocShowModal.vue